import React, { PureComponent } from 'react';
import { Fade } from '../transition';
import { IRoute, pathWithParams } from 'routes/utils';

// Components
import Profile from 'components/user/profile';
import { Link } from 'react-router-dom';
import s from './app-toolbar.scss';
import Button from 'ui/button';

interface AppToolbarProps {
  route: IRoute;
}
class AppToolbar extends PureComponent<AppToolbarProps> {
  handleTabClick = (tab: IRoute) => {
    this.props.onLink(pathWithParams(tab.path, this.props.routeMatch.params));
  };
  render() {
    const { hide, route } = this.props;
    const { routes = [] } = route.parent;
    return (
      <Fade in={!hide} className={s.root}>
        <div className={s.bar}>
          <Link to="/" className={s.logo} />
          {routes.filter(r => !r.hidden).map((r, i) => (
            <Button
              key={i}
              tab
              flat={r.label}
              primary={r === route}
              onClick={() => this.handleTabClick(r)}
            />
          ))}
          <div className="flex" />
          <Profile />
        </div>
      </Fade>
    );
  }
}

export default AppToolbar;
